import { Tooltip } from "@/components/ui/tooltip";
import { SlotRequestEntity } from "@/pages/grain-requests/slot-requests/schema/slot-requests.schema";
import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { Eye } from "lucide-react";

interface Props {
  item: SlotRequestEntity;
  handleDetail: (item: SlotRequestEntity) => void;
}

export const SlotRequestActions = ({
  handleDetail,
  item,
}: Props) => {
  //Acciones para contrato futuro
  return (
    <Tooltip
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={<Text fontSize="14px">Ver detalle</Text>}
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <Flex position="relative">
        <Eye
          cursor="pointer"
          onClick={() => handleDetail(item)}
          data-testid="slot-request-actions-eye"
        />
      </Flex>
    </Tooltip>
  );
};
